import { borderFill, lineDraw } from "../helpers";
import { ComponentF, ComponentO, createElement } from "../ui";

const PanelContents: ComponentF<{ children: ComponentO[] }> = (C, props) => {
  return props.children;
};

export const PanelGroup: ComponentF<{
  children: { title?: string; value: ComponentO }[];
}> = (C, props) => {
  borderFill(C.display, C.bounds);
  let curHeight = 0;
  return props.children.map(({ title, value }) => {
    lineDraw(
      C.display,
      {
        x: 1,
        y: curHeight,
        w: C.bounds.w - 2,
        h: 1,
      },
      title
    );
    const el = createElement(
      PanelContents,
      {
        x: 1,
        y: curHeight + 1,
        w: C.bounds.w - 2,
        h: value.bounds.h,
      },
      {
        children: [value],
      }
    );
    curHeight = curHeight + value.bounds.h + 1;
    return el;
  });
};
